const itemType = (itemId) => {
  const target = document.querySelector(`#draggable-item-container-${itemId}`);
  if (!target) return '';

  return target.dataset.itemType;
};

export default itemType;
